/* Canonical responsive thresholds (design: "OnlyCat Wide Layouts" canvas).
 *
 * compact  (default)          phone: bottom tabs, one pane at a time
 * medium   (>= 768px)         sidebar replaces the tab bar; content panes widen;
 *                             modals are centred dialogs (768 is Ionic's own
 *                             card-modal -> dialog switch, so we align with it)
 * expanded (>= 1100px)        sidebar + list pane + detail pane. 1100 rather than
 *                             Ionic's xl (1200) so iPad landscape (1180-1194)
 *                             qualifies; lg (992) leaves the detail pane too narrow.
 *
 * Use these with useMediaQuery() in JS. CSS modules can't read TS constants, so
 * media queries in CSS must repeat the values verbatim — treat this file as the
 * source of truth when adding one.
 */
export const MEDIUM_MEDIA_QUERY = '(min-width: 768px)';
export const EXPANDED_MEDIA_QUERY = '(min-width: 1100px)';
